export default "__VITE_ASSET__3d45e518__"